<template>
  <el-row style="height: 20px; margin-bottom: 15px">
    <el-col :span="17">
      <el-button type="primary" size="mini" icon="el-icon-circle-plus"
        @click="handleOpenNewIssue(); this.getCustomerCompany();" style="float:left; height: 28px">{{
          $t('home.newIssue',
            { msg: 'home.newIssue' }) }}</el-button>
      <el-input v-model="search" size="mini" :placeholder="$t('issue.search', { msg: 'issue.search' })"
        style=" width: 500px;margin-bottom:10px; float: right" />
      <el-select size="mini" v-model="selectfunc" :placeholder="$t('OM.select', { msg: 'OM.select' })"
        style="margin-right: 5px;width: 100px; float: right;margin-bottom: 10px">
        <el-option v-for="item in allselectfunc" :key="item.value" :label="item.label" :value="item.value">
        </el-option>
      </el-select>
    </el-col>
  </el-row>
  <el-table v-loading="loading" height="90%"
    :data="tableData.filter(data => !search ||
      (selectfunc === 'title' && data.title != undefined && data.title.toLowerCase().includes(search.toLowerCase())) ||
      (selectfunc === 'content' && data.content != undefined && data.content.toLowerCase().includes(search.toLowerCase())) ||
      (selectfunc === 'issueId' && data.identifier != undefined && data.identifier.includes(search)) ||
      (selectfunc === 'solution' && data.solution != undefined && data.solution.toLowerCase().includes(search.toLowerCase())))" ref="issueTable" stripe border
    @row-dblclick="handleOpen" :row-class-name="tableRowClassName" @filter-change="filterChange"
    :header-cell-style="{ background: '#eef1f6', color: '#606266' }"
    :default-sort="{ prop: 'submittime', order: 'descending' }">
    <!--    <el-table-column prop="collection" width="80">-->
    <!--      <template #default="scope">-->
    <!--        <div class="block">-->
    <!--          <el-rate v-model="scope.row.companyID"></el-rate>-->
    <!--        </div>-->
    <!--      </template>-->
    <!--    </el-table-column>-->
    <el-table-column resizable v-if="false" prop="issueid" :label="$t('issue.table.id', { msg: 'issue.table.id' })"
      width="80" sortable>
    </el-table-column>
    <el-table-column resizable prop="urgencyID" :label="$t('issue.table.urgency', { msg: 'issue.table.urgency' })"
      width="100" sortable>
      <template #default="scope">
        <el-badge v-if="scope.row.isRead === 0
          && scope.row.unReadUser === this.creator" :value="scope.row.messageQuantity" :max="99" class="item"
          type="danger" style="position: absolute;margin-left: 35px; margin-top: -10px" />
        <el-tag v-for="item in allurgency.filter(function (item, index, arr) {
          return scope.row.urgencyID === item.value
        })" :key="item.value" effect="dark" :color="item.color" :value="item.label"
          style="border-color: white;border-radius: 20px">
          {{ item.label }}
        </el-tag>
      </template>
    </el-table-column>
    <el-table-column resizable prop="identifier" :label="$t('issue.table.issueId', { msg: 'issue.table.issueId' })"
      width="120" sortable>
    </el-table-column>
    <el-table-column resizable prop="companyID" :label="$t('issue.table.company', { msg: 'issue.table.company' })"
      width="150" column-key="companyID" :filters=allusercompany :filter-method="filterCompanyID"
      filter-placement="bottom-end">
      <template #default="scope">
        <span v-for="item in allusercompany.filter(function (item, index, arr) {
          return scope.row.companyID === item.value
        })" :key="item.value">{{ item.text }}</span>
      </template>
    </el-table-column>
    <el-table-column resizable prop="title" :label="$t('issue.table.title', { msg: 'issue.table.title' })" width="auto">
    </el-table-column>
    <el-table-column resizable prop="type" :label="$t('issue.table.type', { msg: 'issue.table.type' })" width="120"
      column-key="type" :filters="alltype.filter(function (item, index, arr) {
        return filteredCompany.includes(item.companyID)
      })" :filter-method="filterType" filter-placement="bottom-end">
      <template #default="scope">
        <el-select v-model="scope.row.type" size="mini" :placeholder="$t('OM.select', { msg: 'OM.select' })"
          style="width:80px;" v-on:change="typechange(scope.row, scope.row.type)">
          <el-option v-for="item in alltype.filter(function (item, index, arr) {
            return scope.row.companyID === item.companyID
          })" :key="item.value" :label="item.label" :value="item.value">
          </el-option>
        </el-select>
      </template>
    </el-table-column>
    <el-table-column resizable prop="customer" :label="$t('issue.table.customer', { msg: 'issue.table.customer' })"
      width="120" column-key="customer" :filters="allcustomercompany.filter(function (item, index, arr) {
        return filteredCompany.includes(item.companyID)
      })" :filter-method="filterCustomer" filter-placement="bottom-end">
    </el-table-column>
    <el-table-column resizable prop="submittime"
      :label="$t('issue.table.submitTime', { msg: 'issue.table.submitTime' })" width="200" sortable>
    </el-table-column>
    <!-- <el-table-column resizable prop="service" :label="$t('issue.table.cus', { msg: 'issue.table.cus' })" width="160">
    </el-table-column> -->
    <el-table-column resizable prop="status" :label="$t('issue.table.status', { msg: 'issue.table.status' })"
      width="100" column-key="status" :filters=allstatus :filter-method="filterStatus" :filtered-value="['open']"
      filter-placement="bottom-end">
    </el-table-column>
    <!-- <el-table-column :label="$t('issue.table.opr', { msg: 'issue.table.opr' })" width="150">
    <template #default="scope">             
       <el-button
           size="mini"
           type="primary"
           icon="el-icon-s-promotion"
           @click="handleSkip(scope.$index,scope.row)">{{ $t('issue.table.issueTrack', { msg: 'issue.table.issueTrack' }) }}</el-button>
     </template>
   </el-table-column> -->
  </el-table>

  <el-drawer :title="$t('issue.table.issuesolu', { msg: 'issue.table.issuesolu' })" size="90%" v-model="drawer" :before-close="handleClose" destroy-on-close>
    <div class="demo-drawer__content" style="margin-left: 10px;margin-right: 10px">
      <el-descriptions :title="issue.title" direction="vertical" :column="1">
        <el-descriptions-item label="创建人">
          <template #label>{{ $t('issue.table.engineer', { msg: 'issue.table.engineer' }) }}
            {{ issue.engineer }}</template>
        </el-descriptions-item>
        <el-descriptions-item :label="$t('issue.table.createTime', { msg: 'issue.table.createTime' })">
          <template #label>{{ $t('issue.table.createTime', { msg: 'issue.table.createTime' }) }}
            {{ issue.submittime }}</template>
        </el-descriptions-item>
        <el-descriptions-item :label="$t('issue.table.createTime', { msg: 'issue.table.createTime' })">
          <template #label>{{ $t('issue.table.deadLine', { msg: 'issue.table.deadLine' }) }}
            {{ issue.expectFinishTime }}</template>
        </el-descriptions-item>
        <el-descriptions-item v-if="issue.service" label="负责人">
          <template #label>
            {{ $t('issue.table.cus', { msg: 'issue.table.cus' }) }}
            <el-tag size="small">{{ issue.service }}</el-tag> 
          </template>
        </el-descriptions-item>
        <el-descriptions-item>
          <el-radio-group v-model="issue.urgency" :fill="urgencycolor" @change="urgencychange" style="float: left">
            <el-radio-button v-for="item in allurgency" :key="item.value" :label="item.label">
            </el-radio-button>
          </el-radio-group>
        </el-descriptions-item>

        <el-descriptions-item :lable="$t('issue.issueFile', { msg: 'issue.issueFile' })">
          <!--  查询问题附件 &nbsp;&nbsp;<el-button @click="getFilesList(issue.issueid)" type="primary" size="small" >查询附件</el-button>-->
          <el-table :data="filesData" v-loading="load" v-show="filesData.length > 0">
            <el-table-column prop="fileName"
              :label="$t('issue.table.fileName', { msg: 'issue.table.fileName' })"></el-table-column>
            <!-- <el-table-column property="fileUrl" :label="$t('issue.table.path', { msg: 'issue.table.path' })" ></el-table-column> -->
            <el-table-column :label="$t('issue.table.opr', { msg: 'issue.table.opr' })">
              <template #default="scope">
                <el-button size="mini" type="success" @click="handleLoad(scope.$index, scope.row.fileUrl)">{{
                  $t('issue.table.download', { msg: 'issue.table.download' }) }}</el-button>
                <!--  <el-button
            size="mini"
            type="danger"
            @click="handleDelFile(scope.$index, scope.row.id);getFilesList(issue.issueid);">删除</el-button> -->
              </template>
            </el-table-column>
          </el-table>
        </el-descriptions-item>
        <el-descriptions-item :label="$t('issue.table.issueContent', { msg: 'issue.table.issueContent' })">
          <!-- <el-input
              type="textarea"
              :rows="8"
              :placeholder="$t('issue.table.contentD', { msg: 'issue.table.contentD' })"
              v-model="issue.content"
              @change="changeissue">
          </el-input> -->
          <div style="border: 1px solid hsl(133, 36%, 95%);">
            <Editor style="height: auto; overflow-y: hidden;" v-model="issue.content"
              :defaultConfig="contextEditorConfig" :mode="mode" @onCreated="onCreatedContext" />
          </div>

        </el-descriptions-item>

        <!-- 追踪card -->
        <el-descriptions-item>
          <el-timeline :reverse="false">
            <el-timeline-item v-for="(record, index) in recordList" :key="index" :icon='el - icon - more'
              :type='primary' :size='large' color="#0bbd87" :timestamp="record.createTime" placement="top"
              loading="true">

              <el-card class="recordBar">
                <el-badge style="position: absolute; left: 15px; top: 20px" v-if="this.issue.engineer != ''
                  && this.issue.engineer != undefined
                  && this.issue.engineer != 'null'
                  && this.issue.engineer != null
                  && index >= (this.recordList.length - this.issue.messageQuantity)" value="new" type="danger" />
                <h4>{{ record.sender }}&nbsp;<span style="color:rgb(17, 65, 46);font-size:15px;font-weight:bold">{{
                  $t('issueTrack.reply', { msg: 'issueTrack.reply' }) }} </span></h4>
                <template #label><el-text style="font-size: 16px;">{{ $t('issueTrack.content', {
                  msg:
                    'issueTrack.content'
                }) }}</el-text></template>
                <div style="border: 1px solid hsl(133, 36%, 95%);">
                  <Editor style="height: auto; overflow-y: hidden;" v-model="record.issueResponse"
                    :defaultConfig="responseEditorConfig" :mode="mode" @onCreated="onCreatedDispaly" />
                </div>

                <el-table :data="record.urlDTOList"
                  v-if="record.urlDTOList != undefined && record.urlDTOList != null && record.urlDTOList.length > 0">
                  <el-table-column property="imageName"
                    :label="$t('issue.table.fileName', { msg: 'issue.table.fileName' })" width="250"></el-table-column>
                  <!-- <el-table-column property="imageUrl" :label="$t('issue.table.path', { msg: 'issue.table.path' })" ></el-table-column> -->
                  <el-table-column :label="$t('issue.table.opr', { msg: 'issue.table.opr' })" width="150">
                    <template #default="scope">
                      <el-button size="mini" type="success"
                        @click="handleLoadTrace(scope.$index, scope.row.imageUrl)">{{ $t('issue.table.download', {
                          msg:
                            'issue.table.download'
                        }) }}</el-button>
                    </template>
                  </el-table-column>
                </el-table>

              </el-card>
            </el-timeline-item>
          </el-timeline>
        </el-descriptions-item>
        <!-- 对话栏 -->
        <el-descriptions-item>
          <div>
            <h2>{{ $t('issueTrack.dialog', { msg: 'issueTrack.dialog' }) }} </h2>
            <el-card class="duiHua-lan">
              <el-form ref="recordForm" :model="recordForm" label-width="90px" :rules="rulesTrace">
                <!-- <el-form-item :label="$t('issueTrack.replyPerson', { msg: 'issueTrack.replyPerson' })" prop="customerId">
              <el-select v-model="recordForm.customerId" :placeholder="$t('issueTrack.crp', { msg: 'issueTrack.crp' })">
                  <el-option
                    v-for="account in userAccount"
                    :key="account.id"
                    :value="account.id" 
                    :label="account.name"
                    />
              </el-select>
          </el-form-item> -->
                <el-form-item :label="$t('issueTrack.rc', { msg: 'issueTrack.rc' })" prop="contextResp">
                  <div style="border: 1px solid #ccc; z-index: 1;">
                    <Toolbar style="border-bottom: 1px solid #ccc" :editor="editor" :defaultConfig="toolbarConfig"
                      :mode="mode" />
                    <Editor style="height: 280px; overflow-y: hidden;" v-model="recordForm.contextResp"
                      :defaultConfig="editorConfig" :mode="mode" @onChange="onChange" @onCreated="onCreated" />
                  </div>
                </el-form-item>
                <el-form-item :label="$t('issueTrack.uploadImage', { msg: 'issueTrack.uploadImage' })">

                  <el-upload ref='upload' class="upload-demo" :action="uploadUrl" :on-preview="handlePreviewTrace"
                    :on-remove="handleRemoveTrace" :file-list="fileListTarce" :on-success="handleUploadSuccess"
                    :on-change="handleChangeTrace" :before-upload="handleBeforeUpload" :multiple="true">
                    <el-button size="small" type="primary">{{ $t('issueTrack.uploadClick', {
                      msg:
                        'issueTrack.uploadClick'
                    }) }}</el-button>
                    <!-- <div  class="el-upload__tip">{{ $t('issueTrack.uploadInfo', { msg: 'issueTrack.uploadInfo' }) }}</div> -->
                  </el-upload>

                </el-form-item>
                <!-- <el-form-item :label="$t('issueTrack.em', { msg: 'issueTrack.em' })">
            <el-radio v-model="recordForm.isRemind" label="0">{{ $t('issueTrack.norm', { msg: 'issueTrack.norm' }) }}</el-radio>
            <el-radio v-model="recordForm.isRemind" label="1">{{ $t('issueTrack.rm', { msg: 'issueTrack.rm' }) }}</el-radio>
          </el-form-item> -->
                <el-form-item>
                  <el-button size="mini" type="success" icon="el-icon-message" @click="onSubmitTrace('recordForm')" :loading="trackLoad">{{
                    $t('issueTrack.sd', { msg: 'issueTrack.sd' }) }}</el-button>
                  <el-button size="mini" @click="resetForm('recordForm')" type="danger">{{ $t('issueTrack.rs', {
                    msg:
                      'issueTrack.rs'
                  }) }}</el-button>
                </el-form-item>
              </el-form>
            </el-card>
          </div>
        </el-descriptions-item>
        <el-descriptions-item :label="$t('issue.table.solution', { msg: 'issue.table.solution' })">
          <!-- <el-input
              type="textarea"
              :rows="8"
              :placeholder="$t('issue.table.solutionD', { msg: 'issue.table.solutionD' })"
              v-model="issue.solution"
              @change="changeissue">
          </el-input> -->
          <div style="border: 1px solid #ccc; z-index: 1;">
            <Toolbar style="border-bottom: 1px solid #ccc" :editor="solutionEditor" :defaultConfig="toolbarConfig"
              :mode="mode" />
            <Editor style="height: 280px; overflow-y: hidden;" v-model="issue.solution" :defaultConfig="editorConfig"
              :mode="mode" @onChange="onChangeSolution" @onCreated="onCreatedSolution" />
          </div>
        </el-descriptions-item>

        <el-descriptions-item :label="$t('issue.table.remark', { msg: 'issue.table.remark' })">
          <el-input type="textarea" :rows="1" :placeholder="$t('issue.table.remarkD', { msg: 'issue.table.remarkD' })"
            v-model="issue.note" @change="changeissue">
          </el-input>
        </el-descriptions-item>

        <el-descriptions-item :label="$t('issue.table.chargeTime', { msg: 'issue.table.chargeTime' })"
          label-width="100px">
          <el-input @change="updateChargeTime()" type="text" style="width: 400px" v-model="issue.chargeTime">
            <template #append>{{ $t('issue.table.hours', { msg: 'issue.table.hours' }) }}</template>
          </el-input>
        </el-descriptions-item>


        <!-- <el-descriptions-item :label="chargeTime" label-width="100px">
          <el-input
              @change="updateChargeTime()"
              type="text"
              style="width: 400px"
              v-model="issue.chargeTime">
              <template #append>{{ $t('issue.table.hours', { msg: 'issue.table.hours' }) }}</template>
          </el-input>
        </el-descriptions-item> -->

        <!-- <el-descriptions-item :label="$t('issue.table.resFile', { msg: 'issue.table.resFile' })">
          <el-upload
          class="upload-demo"
          ref="upload"
          action=""
          :file-list="resFileList"
          :multiple="true"
          :on-preview="handlePreviewRes"
          :on-change="handleChangeRes"
          :on-remove="handleRemoveRes"
          :auto-upload="false">
          <template #trigger>
          <el-button size="small" type="primary">{{ $t('issue.table.fileC', { msg: 'issue.table.fileC' }) }}</el-button>
          </template>
          <el-button style="margin-left: 10px" size="small" type="success" @click="submitResUpload">{{ $t('issue.table.upServer', { msg: 'issue.table.upServer' }) }}</el-button>
          </el-upload>
        </el-descriptions-item> -->

        <!-- <el-descriptions-item lable="回复附件">

        <el-table :data="resData" v-loading="load">
        <el-table-column prop="resName" :label="$t('issue.table.fileName', { msg: 'issue.table.fileName' })"></el-table-column>
        <el-table-column property="resUrl" :label="$t('issue.table.path', { msg: 'issue.table.path' })"></el-table-column>
        <el-table-column :label="$t('issue.table.opr', { msg: 'issue.table.opr' })">
        <template #default="scope">
        <el-button
            size="mini"
            type="success"
            @click="handleLoad(scope.$index, scope.row.resUrl)">{{ $t('issue.table.download', { msg: 'issue.table.download' }) }}</el-button>
        <el-button
            size="mini"
            type="danger"
            @click="handleDelRes(scope.$index, scope.row.id);">{{ $t('issue.table.delete', { msg: 'issue.table.delete' }) }}</el-button> 
       </template>
        </el-table-column>
        </el-table> 
        </el-descriptions-item> -->

        <el-descriptions-item>
        <div>{{ $t('issue.table.statusTips', { msg: 'issue.table.statusTips' }) }}
        <el-radio-group v-model="issue.status"
                        @change="statuschange(issue.$index, issue, issue.status)">
          <el-radio-button label="close">{{ $t('issue.table.statusClose', { msg: 'issue.table.statusClose' }) }}</el-radio-button>
          <el-radio-button label="cancel">{{ $t('issue.table.statusCancel', { msg: 'issue.table.statusCancel' }) }}</el-radio-button>
          <el-radio-button label="open">{{ $t('issue.table.statusOpen', { msg: 'issue.table.statusOpen' }) }}</el-radio-button>
        </el-radio-group>
      </div>
      </el-descriptions-item>

        <div>
          <el-descriptions-item>
            <el-button size="mini" type="warning" icon="el-icon-s-opportunity" round @click="getrecommendedExpert()"
              v-show="issue.status !== 'close'">{{
                $t('issue.table.getrecommmended', { msg: 'issue.table.getrecommmended' }) }}</el-button>
          </el-descriptions-item>

          <!-- 推荐专家信息对话框 -->

        </div>

        <!-- 推荐专家信息对话框 -->
        <!-- <recommended-experts-dialog v-model="dialogVisible" :experts="experts"></recommended-experts-dialog> -->
        <el-descriptions-item>
          <el-button size="mini" type="warning" icon="el-icon-s-opportunity" round
            @click="importIssueToKB(issue.$index, issue);" v-show="this.issue.status === 'close'">{{
              $t('issue.table.exportKb', { msg: 'issue.table.exportKb' }) }}</el-button>
        </el-descriptions-item>

      </el-descriptions>
      <!--          <div class="demo-drawer__footer">-->
      <!--            <el-button @click="cancelForm">取 消</el-button>-->
      <!--            <el-button type="primary" @click="drawer = false" :loading="loading">{{ loading ? '提交中 ...' : '确 定' }}</el-button>-->
      <!--          </div>-->
    </div>
  </el-drawer>
  <!-- 导入知识库选择知识类型 -->
  <el-dialog :title="$t('issue.table.importKBBag', { msg: 'issue.table.importKBBag' })" v-model="dialogTypeVisible" >
    <!-- 知识类别级联列表 -->
    <el-cascader 
                :placeholder="$t('kbinfo.kbTypeD', { msg: 'kbinfo.kbTypeD' })"
                ref="refCascader"
                @change="handleCascader"
                :options="typeTree" 
                v-model="kbTypeId" 
                :props="{
                  value: 'id',
                  label: 'type'
                }"
                 style="width: 100%;"
                ></el-cascader>
  <div style="text-align: left;margin-top: 56px;" >
    <el-button @click="dialogTypeVisible = false"> {{ $t('issue.table.cancel', { msg: 'issue.table.cancel' }) }} </el-button>
    <el-button type="primary" @click="importKBBag"> {{ $t('issue.table.importKBBag', { msg: 'issue.table.importKBBag' }) }} </el-button>
  </div>
</el-dialog>
  <el-dialog :title="$t('issue.table.newIssue', { msg: 'issue.table.newIssue' })" v-model="issueDialogVisible"
    width="72%" :before-close="issueDialogClose">
    <el-form :rules="rules" ref="form" :model="form" label-width="100px" status-icon="true">
      <el-form-item :label="$t('issue.table.company', { msg: 'issue.table.company' })" prop="companyID">
        <el-col :span="8">
          <el-select v-model="form.companyID" :placeholder="$t('issue.table.companyD', { msg: 'issue.table.companyD' })"
            @change="companyChange(form.companyID)">
            <el-option v-for="item in allusercompany" :key="item.value" :label="item.label" :value="item.value">
            </el-option>
          </el-select>
        </el-col>
      </el-form-item>


      <!-- <el-form-item :label="$t('issue.table.title', { msg: 'issue.table.title' })" prop="title">
        <el-input v-model="form.title" type="textarea" :placeholder="$t('issue.table.titleD', { msg: 'issue.table.titleD' })" maxlength="255" show-word-limit style="float: left;" ></el-input>
      </el-form-item> -->
      <el-form-item :label="title" prop="title">
        <el-input v-model="form.title" type="textarea"
          :placeholder="$t('issue.table.titleD', { msg: 'issue.table.titleD' })" maxlength="255" show-word-limit
          style="float: left;"></el-input>
      </el-form-item>





      <el-form-item :label="$t('issue.table.type', { msg: 'issue.table.type' })" prop="type">
        <el-col :span="8">
          <el-select v-model="form.type" :placeholder="$t('issue.table.typeD', { msg: 'issue.table.typeD' })">
            <el-option v-for="item in alltype.filter(function (item, index, arr) {
              return form.companyID === item.companyID && item.disable === 0
            })" :key="item.value" :label="item.label" :value="item.value">
            </el-option>
          </el-select>
        </el-col>
      </el-form-item>
      <el-form-item :label="$t('issue.table.customer', { msg: 'issue.table.customer' })" prop="customerid"
        v-show="true">
        <el-col :span="8">
          <el-select v-model="form.customerid" filterable allow-create
            :placeholder="$t('issue.table.customerD', { msg: 'issue.table.customerD' })">
            <el-option v-for="item in allcustomercompany.filter(function (item, index, arr) {
              return form.companyID === item.companyID
            })" :key="item.value" :label="item.label" :value="item.value">
            </el-option>
          </el-select>
        </el-col>
      </el-form-item>
      <el-form-item :label="$t('issue.deadLine', { msg: 'issue.deadLine' })" prop="expectFinishTime">
        <el-col :span="8">
          <el-date-picker formate="YYYY-MM-dd HH:mm:ss" value-format="YYYY-MM-DD HH:mm:ss" style="width: 300px"
            clearable size="large" v-model="form.expectFinishTime" type="datetime"
            :placeholder="$t('issue.selectTime', { msg: 'issue.selectTime' })" />
        </el-col>
      </el-form-item>
      <el-form-item :label="$t('issue.table.issueContent', { msg: 'issue.table.issueContent' })" prop="content">
        <!-- <el-input type="textarea" v-model="form.content" :placeholder="$t('issue.table.contentD', { msg: 'issue.table.contentD' })"></el-input> -->
        <div style="border: 1px solid #ccc; z-index: 1;">
          <Toolbar style="border-bottom: 1px solid #ccc" :editor="editor" :defaultConfig="toolbarConfig" :mode="mode" />
          <Editor style="height: 250px; overflow-y: hidden;" v-model="form.content" :defaultConfig="editorConfig"
            :mode="mode" @onChange="onChange" @onCreated="onCreated" />
        </div>
      </el-form-item>

      <el-form-item :label="$t('issue.table.uploadFile', { msg: 'issue.table.uploadFile' })" label-width="100px"
        prop="fileUrl" enctype="multipart/form-data">
        <el-upload class="pop-upload" ref="upload" action="" :file-list="fileList" :auto-upload="false" :multiple="true"
          :on-preview="handlePreview" :on-change="handleChange" :on-remove="handleRemove">
          <template #trigger>
            <el-button size="small" type="primary">{{ $t('issue.table.fileC', { msg: 'issue.table.fileC' })
              }}</el-button>
          </template>
          <el-button size="small" type="success" style="margin-left: 10px" @click="submitUpload">{{
            $t('issue.table.upServer', { msg: 'issue.table.upServer' }) }}</el-button>
        </el-upload>
      </el-form-item>

      <el-form-item :label="$t('issue.table.remark', { msg: 'issue.table.remark' })" prop="note">
        <el-input type="textarea" v-model="form.note"
          :placeholder="$t('issue.table.remarkD', { msg: 'issue.table.remarkD' })"></el-input>
      </el-form-item>



      <!--      <el-form-item :label="$t('issue.table.chargeTime', { msg: 'issue.table.chargeTime'})" prop="chargeTime">
        <el-input
              type="text"
              :placeholder="$t('issue.table.chargeTimeD', { msg: 'issue.table.chargeTimeD' })"
              v-model="form.chargeTime"
              maxlength="10"
              show-word-limit>
              <template #append>{{ $t('issue.table.hours', { msg: 'issue.table.hours' }) }}</template>
          </el-input>
      </el-form-item> -->



      <!-- <el-form-item :label="remark" prop="note">
        <el-input type="textarea" v-model="form.note" :placeholder="$t('issue.table.remarkD', { msg: 'issue.table.remarkD' })"></el-input>
      </el-form-item> -->
      <el-form-item :label="chargeTime">
        <el-input type="text" :placeholder="$t('issue.table.chargeTimeD', { msg: 'issue.table.chargeTimeD' })"
          v-model="form.chargeTime" maxlength="10">
          <template #append>{{ hours }}</template>
        </el-input>
      </el-form-item>

      <!-- show-word-limit> -->




      <el-form-item :label="$t('issue.table.urgency', { msg: 'issue.table.urgency' })" prop="urgency">
        <el-radio-group v-model="form.urgency" :fill="urgencyradiocolor" @change="urgencyRadioChange"
          style="float: left">
          <el-radio-button v-for="item in allurgency" :key="item.value" :label="item.label">
          </el-radio-button>
        </el-radio-group>
      </el-form-item>
      <el-form-item style="text-align: left">
        <el-button type="primary" :loading="loadBtn" @click="onSubmit('form')">{{ $t('issue.table.confirm', {
          msg:
            'issue.table.confirm'
        }) }}</el-button>
        <el-button @click="issueDialogVisible = false">{{ $t('issue.table.cancel', { msg: 'issue.table.cancel' })
          }}</el-button>
      </el-form-item>
    </el-form>
    </el-dialog>

    <el-dialog v-model="dialogVisible" title="专家推荐" :width="'70%'">
      <el-table :data="experts" style="width: 100%">
        <el-table-column type="expand">
          <template #default="props">
            <el-form label-position="left" inline class="demo-table-expand" style="text-align: left;">

                <el-form-item label="语言">
                  <el-tag
                    v-for="(language, index) in props.row.expertLanguages"
                    :key="index"
                    type="success"
                    class="tag-margin"
                  >
                    {{ language }}
                  </el-tag>
                </el-form-item>
 

                <!-- <el-form-item label="标签">
                  <el-tag
                    v-for="(label, index) in props.row.expertLabels"
                    :key="index"
                    type="success"
                    class="tag-margin"
                  >
                    {{ label }}
                  </el-tag>
                </el-form-item> -->
              <el-form-item label="简介">
                <span class="biography">{{ props.row.biography }}</span>
              </el-form-item>
            </el-form>
          </template>
        </el-table-column>
        <el-table-column prop="name" label="姓名" width="180"></el-table-column>
        <el-table-column prop="email" label="邮箱" width="180">
          <template #default="scope">
            <el-tooltip content="点击复制" placement="top">
              <el-button type="text" @click="copyToClipboard(scope.row.email)">
                {{ scope.row.email }}
              </el-button>
              </el-tooltip>
            
          </template>
        </el-table-column>
        <el-table-column prop="yearsOfExperience" label="工作年限" width="180">
          <template #default="scope">
            <el-tag type="primary">{{ scope.row.yearsOfExperience }} 年</el-tag>
          </template>
        </el-table-column>
        <el-table-column prop="rating" label="评分" width="180">
          <template #default="scope">
            <el-rate v-model="scope.row.rating" disabled show-score></el-rate>
          </template>
        </el-table-column>
        <el-table-column prop="label" label="标签" width="180">
          <template #default="scope">
            <el-tag
                    v-for="(label, index) in scope.row.expertLabels"
                    :key="index"
                    type="success"
                    class="tag-margin"
                  >
                    {{ label }}
                  </el-tag>          </template>
        </el-table-column>

      </el-table>
      <template #footer>
        <el-button @click="closeDialog">关闭</el-button>
      </template>
    </el-dialog>
    
</template>



<script>
import {
  uploadRes,
  issueFileAdd,
  uploadFile,
  addRowIssue,
  changeurgency,
  changeissue,
  deleteIssue,
  getallcustomer,
  getalltype, getallurgency, getcustomercompany,
  getDemo, getusercompany, insertcustomercompany,
  updStatus, getallrole, changeChargeTime
} from "../../axios";
import { baseUrl_New } from "../../axios/urlconfig";
import { ElMessage } from "element-plus";
import { Editor, Toolbar } from '@wangeditor/editor-for-vue'
import { i18nChangeLanguage } from '@wangeditor/editor';
import { deleteRequest, getRequest, postRequest,getLoadRequest } from '../../axios/axios';
import RecommendedExpertsDialog from '../expert/expertrecommended.vue'; // 引入你创建的对话框组件


export default {
  components: { Editor, Toolbar },
  name: "issue",
  props: ['userid', 'username', 'realname', 'role', 'companyID', 'usercompany'],
  data() {
    // const item = {
    //   id: 'MAC237',
    //   title: '问题1',
    //   customer: 'Cherry',
    //   submittime: '2014/1/1 8:00',
    //   service: 'Sophia',
    //   status: '进行中'
    // };
    return {
      dialogVisible: false,
      experts: [],
      selectfunc: 'issueId',
      trackLoad:false,

      title: '标题',
      chargeTime: '收费时间',
      hours: 'Hours',


      creator: '',
      allurgency: [{
        label: '一般',
        value: 0,
        color: '#67C23A'
      }, {
        label: '次要',
        value: 1,
        color: '#409EFF'
      }, {
        label: '重要',
        value: 2,
        color: '#E6A23C'
      }, {
        label: '严重',
        value: 3,
        color: '#F56C6C'
      }],
      allselectfunc: [
        {
          label: this.$t('issue.table.issueId', { msg: 'issue.table.issueId' }),
          value: 'issueId'
        },
        {
          label: this.$t('issue.table.title', { msg: 'issue.table.title' }),
          value: 'title'
        },
        {
          label: this.$t('valueChain.content', { msg: 'valueChain.content' }),
          value: 'content'
        },
        {
          label: this.$t('kbReview.table.solution', { msg: 'kbReview.table.solution' }),
          value: 'solution'
        }
      ],
      //上传
      headers: {
        "content-type": "multipart/form-data"
      },
      fileType: ["pdf", "doc", "docx", "xls", "xlsx", "txt", "png", "jpg", "bmp", "jpeg"],
      fileSize: 500,
      fileLimit: 3,
      fileList: [], //文件列表
      resFileList: [],
      urlFile: '',  //文件返回值
      urlFiles: [],
      filesData: [],  //新增文件列表
      resData: [],  //回复文件列表
      load: true,
      fd: {},
      loadBtn: false,
      message: this.$t('issue.plzUploadFile', { msg: 'issue.plzUploadFile' }),
      urls: [
        'https://fuss10.elemecdn.com/a/3f/3302e58f9a181d2509f3dc0fa68b0jpeg.jpeg',
        'https://fuss10.elemecdn.com/1/34/19aa98b1fcb2781c4fba33d850549jpeg.jpeg',
        'https://fuss10.elemecdn.com/0/6f/e35ff375812e6b0020b6b4e8f9583jpeg.jpeg',
        'https://fuss10.elemecdn.com/9/bb/e27858e973f5d7d3904835f46abbdjpeg.jpeg',
        'https://fuss10.elemecdn.com/d/e6/c4d93a3805b3ce3f323f7974e6f78jpeg.jpeg',
        'https://fuss10.elemecdn.com/3/28/bbf893f792f03a54408b3b7a7ebf0jpeg.jpeg',
        'https://fuss10.elemecdn.com/2/11/6535bcfb26e4c79b48ddde44f4b6fjpeg.jpeg'
      ],
      filteredCompany: [],
      allusercompany: [],
      allcustomer: [], //具有账号的客户
      allcustomercompany: [], //所有客户
      allstatus: [{
        text: 'open',
        value: 'open'
      },{
        text: 'cancel',
        value: 'cancel'
      },{
        text: 'close',
        value: 'close'
      }],
      allrole: [],
      alltype: [{
        text: '技术',
        label: '技术',
        value: '技术'
      }, {
        text: '财务',
        label: '财务',
        value: '财务'
      }],
      issue: null, //单个问题
      //tableData: Array(20).fill(item),
      form: { //新增问题
        title: '',
        type: '',
        customerid: '',
        content: '',
        fileUrl: '',
        note: '',
        companyID: parseInt(this.companyID[0], 10),
        urgency: '',
        chargeTime: 0,
        engineer: '',
        expectFinishTime: '',
      },
      rules: {
        title: [
          { required: true, message: this.$t('issue.table.titleD', { msg: 'issue.table.titleD' }), trigger: 'blur' }
        ],
        type: [
          { required: true, message: this.$t('issue.table.typeD', { msg: 'issue.table.typeD' }), trigger: 'change' }
        ],
        companyID: [
          { required: true, message: this.$t('issue.table.companyD', { msg: 'issue.table.companyD' }), trigger: 'change' }
        ],
        customerid: [
          { required: true, message: this.$t('issue.table.customerD', { msg: 'issue.table.customerD' }), trigger: 'blur' },
          { pattern: /^\S(.*\S)?$/, message: this.$t('issue.table.customerInfo', { msg: 'issue.table.customerInfo' }), trigger: 'blur' }
        ],
        content: [
          { required: true, message: this.$t('issue.table.contentD', { msg: 'issue.table.contentD' }), trigger: 'blur' }
        ],
        chargeTime: [
          { pattern: /^[0-9]+(\.[0-9]+)?$/, message: this.$t('powerDomain.info', { msg: 'powerDomain.info' }), trigger: 'blur' }
        ]
      },
      tableData: [],
      // tableData: [{
      //   issueid: 'MAC237',
      //   title: '问题1',
      //   type: '财务',
      //   customer: 'Cherry',
      //   submittime: '2014/1/1 8:00',
      //   service: 'Sophia',
      //   status: 'open',
      //   content: 'xxxxxxxxxxxxxxx',
      //   solution: 'xxxxxxxxxxxxxxx',
      //   note: 'xxxxxxxxxxxxxxx',
      //   companyID: 1
      // },{
      //   issueid: 'MAC237',
      //   title: '问题2',
      //   type: '财务',
      //   customer: 'Cherry',
      //   submittime: '2014/1/1 8:00',
      //   service: 'Sophia',
      //   status: 'open',
      //   content: 'xxxxxxxxxxxxxxx',
      //   solution: 'xxxxxxxxxxxxxxx',
      //   note: 'xxxxxxxxxxxxxxx',
      //   companyID: 1
      // },{
      //   issueid: 'MAC237',
      //   title: '问题3',
      //   type: '财务',
      //   customer: 'Cherry',
      //   submittime: '2014/1/1 9:00',
      //   service: 'Sophia',
      //   status: 'open',
      //   content: 'xxxxxxxxxxxxxxx',
      //   solution: 'xxxxxxxxxxxxxxx',
      //   note: 'xxxxxxxxxxxxxxx',
      //   companyID: 1
      // },{
      //   issueid: 'MAC237',
      //   title: '问题4',
      //   type: '财务',
      //   customer: 'Cherry',
      //   submittime: '2015/1/1 8:00',
      //   service: 'Sophia',
      //   status: 'open',
      //   content: 'xxxxxxxxxxxxxxx',
      //   solution: 'xxxxxxxxxxxxxxx',
      //   note: 'xxxxxxxxxxxxxxx',
      //   companyID: 1
      // },{
      //   issueid: 'MAC237',
      //   title: '问题5',
      //   type: '财务',
      //   customer: 'Cherry',
      //   submittime: '2016/1/1 8:00',
      //   service: 'Sophia',
      //   status: 'open',
      //   content: 'xxxxxxxxxxxxxxx',
      //   solution: 'xxxxxxxxxxxxxxx',
      //   note: 'xxxxxxxxxxxxxxx',
      //   companyID: 1
      // }
      // ],
      drawer: false, //右边抽屉
      formLabelWidth: '80px',
      search: '',
      issueDialogVisible: false,
      typeDialogVisible: false,
      customerVisible: false,
      loading: true,
      urgencyradiocolor: '#409EFF', //新增问题中优先级按钮颜色
      urgencycolor: '#409EFF',//抽屉中新增问题优先级按钮
      emailList: [], //用户邮箱
      dialogFormVisible: false,  //邮箱弹窗
      issueIdTo: '',
      companyCache: '',
      //问题追踪
      rulesTrace: {
        // customerId: [
        //   { required: true, message: this.$t('issueTrack.crp', { msg: 'issueTrack.crp' }), trigger: 'change' }
        // ],
        contextResp: [
          { required: true, message: this.$t('issueTrack.responseText', { msg: 'issueTrack.responseText' }), trigger: 'blur' }
        ],
      },
      recordForm: {
        customerId: '',
        receiver: '',
        email: '',
        contextResp: "",
        isRemind: '0',
        stringUrl: [],
      },
      typeUserId: '',//问题类型userId
      typeCompanyId: '',//问题类型companyId
      typeId: [],
      userAccount: [],
      recordCard: [{
        id: '',
        sender: '',
        receiver: '',
        issueResponse: '',
        createTime: '',
      }],
      imgList: [
        { id: 0, idView: 'https://srb-data.oss-cn-beijing.aliyuncs.com/resFile/2023/12/08/120801.png' },
        { id: 1, idView: 'https://srb-data.oss-cn-beijing.aliyuncs.com/resFile/2023/12/06/help-right.png' }
      ],
      uploadUrl: baseUrl_New + "/oss/file/uploadFile",//图片上传
      fileListTarce: [],
      imageUrl: '',
      imageUrlList: [],
      recordId: '',
      recordList: [{
        "id": '',
        sender: '',
        receiver: '',
        issueResponse: '',
        isRemind: '',
        createTime: '',
        urlDTOList: [
          {
            id: '',
            imageName: '',
            imageUrl: '',
          }
        ],
      }],
      //富文本编辑
      editor: null,
      html: '',
      toolbarConfig: {
        // showLinkImg: false,
        //uploadImgShowBase64: false,
        excludeKeys: [  //删除工具栏的插件
          'insertVideo', // 删除视频
          'uploadVideo',
          'group-video',
          //'insertImage',// 删除网络图片上传
          'insertLink',// 删除链接
          'codeBlock',// 删除代码块
          "emotion", //表情
          //"uploadImage",//删除图片
          //"insertTable", // 插入表格删除
        ]
      },
      editorConfig: {
        placeholder: this.$t('issue.issueD', { msg: 'issue.issueD' }),
        readOnly: false, // 是否只允许阅读，不可编辑
        //autoFocus: true,
        MENU_CONF: {
          // 配置上传图片,只允许base64上传
          uploadImage: {
            server: baseUrl_New + '/oss/file/uploadEditor', // 上传接口
            fieldName: 'file',
            allowedFileTypes: ['image/*'],
            maxFileSize: 5 * 1024 * 1024, // 5M
            // base64LimitSize: 1 * 1024 * 1024, // 1g 以下插入 base64
            // 将 meta 拼接到 url 参数中，默认 false
            // metaWithUrl: false,
            onSuccess(file, res) {          // JS 语法
              console.log(`${file.name} 上传成功`, res)
            },

            // 自定义上传
            // customInsert(res, insertFn) {
            //insertFn(res[0].url); //同步插入,顺序不会乱
            //  },

            onError: (file, err, res) => {
              this.$message.warning('当前选择的图片过大！请选择5M以内')
            },
          },
        }

      },
      mode: 'default', // or 'simple', 
      responseEditorConfig: {
        placeholder: '请输入内容...',
        readOnly: true, // 是否只允许阅读，不可编辑
      },
      responseEditor: null,
      contextEditorConfig: { //issue抽屉得内容
        placeholder: '请输入内容...',
        readOnly: true, // 是否只允许阅读，不可编辑
      },
      contextEditor: null,
      solutionEditor: null,
      loginName: '',
      defaultCompany: '',
      kbImport:{
        title:'',
        typeId:'',
        creator:'',
        solution:''
      },
      dialogTypeVisible:false,
      typeTree:[],//知识类别两层结构
      kbTypeId:'',
    }
  },
  created() {
    this.getCustomizeLabel();

    this.getTypeId();
    // this.updatetable();
    this.getLoginUserName();
    this.getAllType();
    this.getUserCompany();
    this.getAllUrgency();
    this.getallrole();
    this.getCustomerCompany();
    this.getCreatorName();
    // this.getCompanyCache();
  },
  beforeUnmount() {
    const editor = this.editor
    if (editor == null) return
    editor.destroy() // 组件销毁时，及时销毁编辑器
    const solutionEditor = this.solutionEditor
    if (solutionEditor == null) return
    solutionEditor.destroy()
  },

  methods: {
    // getrecommendedExpert() {
    //   const type = this.issue.type;
    //   const label = null;
    //   console.log('asfaf');
    //   getRequest(baseUrl_New + '/expert/labelid?labelId='+type).then(res =>{
    //     label = res.data.data
    //     console.log('11'+res.data.data);
    //   })
    //   console.log(label)
    //   getRequest(baseUrl_New + '/expert/recommend?label='+label).then(res => {
    //     const items = res.data.data;
    // this.experts = items;

    // // 检查和映射 expertLanguages
    // this.experts.forEach(expert => {
    //   expert.expertLanguages = expert.expertLanguages.map(language => language.language);
    // });

    // // 检查和映射 expertLabels
    // this.experts.forEach(expert => {
    //   expert.expertLabels = expert.expertLabels.map(label => label.label);
    // });

    // // 检查和映射 qualifications
    // this.experts.forEach(expert => {
    //   expert.qualifications = expert.qualifications.map(qualification => qualification.qualification);
    // });
    //   }).catch(err => {
    //     console.log(err);
    //   });
    //   this.dialogVisible = true;

    // },
    getrecommendedExpert() {
  const type = this.issue.type;
  let label = null;  // 使用let代替const，因为label需要重新赋值
  console.log('asfaf');
  
  // 第一个异步请求获取label
  getRequest(baseUrl_New + '/expert/labelid?labelId=' + type).then(res => {
    label = res.data.data;
    console.log('11' + res.data.data);

    // 确保在获取到label后再进行第二个请求
    getRequest(baseUrl_New + '/expert/recommend?label=' + label).then(res => {
      const items = res.data.data;
      this.experts = items.map(expert => ({
        ...expert,
        expertLanguages: expert.expertLanguages.map(language => language.language),
        expertLabels: expert.expertLabels.map(label => label.label),
        qualifications: expert.qualifications.map(qualification => qualification.qualification)
      }));
      this.dialogVisible = true;  // 在获取到专家数据后再显示对话框
    }).catch(err => {
      console.log(err);
    });
  }).catch(err => {
    console.log(err);
  });

  // 在这里打印label仍然会是null，因为这是异步操作
  console.log(label);
},

    getCustomizeLabel() {
      //console.log(localStorage);
      const locallan = localStorage.getItem("language");
      //console.log(locallan + 'lallalla');
      const companyIDString = sessionStorage.getItem("companyID"); // "4,8,3,31,32,24"
      const companyIDArray = companyIDString.split(','); // ["4", "8", "3", "31", "32", "24"]
      const comone = companyIDArray[0]; // "4"
      getRequest(baseUrl_New + '/issue/customizelabel/' + comone).then(res => {
        const items = res.data.data;
        items.forEach(item => {
          if (item.label === 'title') {
            this.title = locallan === 'zh-cn' ? item.labelCn : item.labelEn;
          } else if (item.label === 'chargeTime') {
            this.chargeTime = locallan === 'zh-cn' ? item.labelCn : item.labelEn;
          } else if (item.label === 'hours') {
            this.hours = locallan === 'zh-cn' ? item.labelCn : item.labelEn;
          }
        })
      }).catch(err => {
        console.log(err);
      });
    },

    handleOpenNewIssue() {
      this.getCompanyCache();
      this.issueDialogVisible = true;
    },
    getAllCustomer() {
      getallcustomer().then(res => {
        this.allcustomer = res.data;
        // console.log(res);
      }).catch(err => {
        console.log(err);
      });
    },
    getAllUrgency() {  //获得所有优先级信息
      getallurgency().then(res => {
        this.allurgency.splice(0, this.allurgency.length);
        for (let i = 0; i < res.count; i++) {
          this.allurgency.push({
            text: res.data[i].label,
            label: res.data[i].label,
            value: res.data[i].id,
            color: res.data[i].color
          });
        }
        // console.log(res);
      }).catch(err => {
        console.log(err);
      });
      if (this.allurgency.length > 0) {
        this.form.urgency = this.allurgency[0].label;
        this.urgencyradiocolor = this.allurgency[0].color;
      }
    },
    getCustomerCompany() { //得到用户公司所有的客户姓名
      getcustomercompany({ companyID: this.companyID }).then(res => {
        this.allcustomercompany.splice(0, this.allcustomercompany.length);
        for (let i = 0; i < res.count; i++) {
          this.allcustomercompany.push({
            text: res.data[i].name,
            label: res.data[i].name,
            value: res.data[i].name,
            companyID: res.data[i].companyID
          });
        }
        this.allcustomercompany.sort(function (a, b) {
          if (typeof a.label == "string" && typeof b.label == "string") {
            return a.label.localeCompare(b.label);
          }
        }); //将公司根据公司名排序
        // console.log(res);
      }).catch(err => {
        console.log(err);
      });
    },
    getAllType() { //获得所有问题类型
      getalltype().then(res => {
        this.alltype.splice(0, this.alltype.length);
        for (let i = 0; i < res.count; i++) {
          this.alltype.push({
            text: res.data[i].name,
            label: res.data[i].name,
            value: res.data[i].type,
            disable: res.data[i].disable,
            companyID: res.data[i].companyID
          });
        }
        // console.log(res);
      }).catch(err => {
        console.log(err);
      });
    },
    getUserCompany() { //获得用户的公司信息
      getusercompany({
        companyID: this.companyID
      }).then(res => {
        this.allusercompany.splice(0, this.allusercompany.length);
        for (let i = 0; i < res.count; i++) {
          this.allusercompany.push({ text: res.data[i].companyname, label: res.data[i].companyname, value: res.data[i].companyID });
        }
        this.allusercompany.sort(function (a, b) { return a.label > b.label ? 1 : -1; }); //将公司根据公司名排序
        // console.log(res);
      }).catch(err => {
        console.log(err);
      });
    },
    filterStatus(value, row) { //筛选状态
      return row.status === value;
    },
    filterType(value, row) { //筛选类型
      return row.type === value;
    },
    filterCompanyID(value, row) { //筛选公司
      return row.companyID === value;
    },
    filterCustomer(value, row) { //筛选客户
      return row.customer === value;
    },
    filterChange(filters) {
      if (filters.companyID != undefined) {
        this.filteredCompany = filters.companyID;
        sessionStorage.setItem('defaultCompany', this.filteredCompany);
        if (this.filteredCompany.length == 0)
          this.$refs.issueTable.clearFilter('type');
      }
    },
    changeissue(value) {  //修改问题内容，解决方案以及备注
      changeissue(this.issue).then(res => {
        // console.log(res);
      }).catch(err => {
        console.log(err);
      });

    },
    resetIssueForm() {
      this.issueDialogVisible = false;
      this.form.content = '';
      this.form.fileUrl = '';
      this.form.note = '';
      this.form.type = '';
      this.form.title = '';
      this.form.companyID = '';
      this.form.customerid = '';
      this.form.chargeTime = 0.00;
      this.customerVisible = false;
      this.form.expectFinishTime = '';
      this.updatetable();
      this.loadBtn = false;
    },
    onSubmit(formName) {
      //新增问题
      if (this.customerVisible === false) {
        // this.form.customerid = this.realname;
      }
      let urgencyID;
      for (let i = 0; i < this.allurgency.length; i++) {  //获得优先级ID
        if (this.allurgency[i].label === this.form.urgency) {
          urgencyID = this.allurgency[i].value;
          break;
        }
      }
      this.$refs[formName].validate((valid) => {
        if (valid) {
          this.loadBtn = true;
          addRowIssue({
            'username': sessionStorage.getItem('username'),
            'type': this.form.type,
            'title': this.form.title,
            'content': this.form.content,
            'fileUrl': this.urlFiles,
            'note': this.form.note,
            'customer': this.form.customerid,
            'companyID': this.form.companyID,
            'urgencyID': urgencyID,
            'chargeTime': this.form.chargeTime,
            'engineer': this.form.engineer,
            'expectFinishTime': this.form.expectFinishTime,
          }).then(res => {
            if (res === '新增成功') {
              this.resetIssueForm();
              this.$message.success(this.$t('issue.addS', { msg: 'issue.addS' }));
            } else {
              this.loadBtn = false;
              this.$message.error(this.$t('issue.addF', { msg: 'issue.addF' }));
            }
          }).catch(err => {
            console.log(err);
          });
          let isnewcustomer = true;
          for (let i = 0; i < this.allcustomercompany.length; i++) {
            if (this.allcustomercompany[i].value == this.form.customerid
              && this.allcustomercompany[i].companyID == this.form.companyID) {
              isnewcustomer = false;
              break;
            }
          }
          if (isnewcustomer) {
            insertcustomercompany({
              name: this.form.customerid,
              companyID: this.form.companyID
            }).then(res => {
              // console.log(res);
            }).catch(err => {
              console.log(err);
            });
          }
        } else {
          console.log('error submit!!');
          return false;
        }
      });
    },
    getTypeId() {
      this.typeUserId = sessionStorage.getItem("userid");
      this.typeCompanyId = sessionStorage.getItem("companyID");
      getRequest(baseUrl_New + '/auth/getTypeId?userId=' + this.typeUserId + '&companyId=' + this.typeCompanyId)
        .then(res => {
          this.typeId = res.data.list;
          this.loading = true;
          let isAdmin = false;
          const roles = sessionStorage.getItem('role');
          if (roles.includes("超级管理员")) {
            isAdmin = true;
          }
          this.typeId = res.data.list;
          this.typeId = this.typeId.join(',');
          sessionStorage.setItem('isAdmin', isAdmin);
          const data = {
            'companyID': this.companyID,
            'isAdmin': isAdmin,
            'typeId': this.typeId
          }
          getRequest(baseUrl_New + '/issuecompany', data).then(res => {
            // console.log(res);
            this.tableData = res.data;
            this.loading = false;
          }).catch(err => {
            console.log(err);
          });
        }).catch(err => {
          console.log(err);
        })
    },

    updatetable() {  //重新获取表格数据
      this.loading = true;
      let isAdmin = false;
      const roles = sessionStorage.getItem('role');
      if (roles.includes("超级管理员")) {
        isAdmin = true;
      }
      sessionStorage.setItem('isAdmin', isAdmin);
      const data = {
        'companyID': this.companyID,
        'isAdmin': isAdmin,
        'typeId': this.typeId
      }
      getRequest(baseUrl_New + '/issuecompany', data).then(res => {  //传参有问题
        // console.log(res);
        this.tableData = res.data;
        this.loading = false;
      }).catch(err => {
        console.log(err);
      });
    },
    statuschange(index, row, status) { //状态改变
      if (row.issueid != undefined && row.issueid != '' && status != undefined && status != '') {
        updStatus({
          issueid: row.issueid,
          status: status
        }).then(res => {
          // console.log(res);
        }).catch(err => {
          console.log(err);
        })
      }
    },
    getCreatorName() {
      this.creator = sessionStorage.getItem('name');
    },
    importIssueToKB(index, row){
      this.kbImport.title = row.title;
      this.kbImport.solution = row.solution;  //这里传入空值 null
      this.kbImport.creator = this.creator;
      this.dialogTypeVisible = true;
      this.getTypeTree();
    },
    getTypeTree(){ //获取知识类别
        getRequest(baseUrl_New+'/kType/getType').then(response=>{
          console.log(response);
            let resultMap = response.data;
            this.typeTree=resultMap.typeTree;
          })
      },
    handleCascader(){
        this.kbTypeId = this.$refs["refCascader"].getCheckedNodes()[0].value; //获取最后一个id
      },
      //导入知识库审核列表
      importKBBag() {
         // 1. 非空校验
        if (!this.kbTypeId || this.kbTypeId.length === 0) {
          this.$message.warning(this.$t('issue.table.importKBTips', { msg: 'issue.table.importKBTips' }));
          return;
        }
      this.$confirm(this.$t('issue.kbInfo', { msg: 'issue.kbInfo' }), this.$t('issue.tips', { msg: 'issue.tips' }), {
        confirmButtonText: this.$t('issue.table.confirm', { msg: 'issue.table.confirm' }),
        cancelButtonText: this.$t('issue.table.cancel', { msg: 'issue.table.cancel' }),
        cancelButtonClass: 'btn-custom-cancel',
        type: 'warning'
      }).then(() => {
        var that = this
        postRequest(baseUrl_New + '/kb/importKB', {
          typeId: this.kbTypeId,
          title: this.kbImport.title,
          solution: this.kbImport.solution,  //这里传入空值 null
          creator: this.kbImport.creator,
        }).then(res => {
          let responseMsg = ''
          let responseType = '';
          if (res.message === '导入成功') {
            this.dialogTypeVisible = false;
            responseType = 'success';
            responseMsg = this.$t('issue.importKbS', { msg: 'issue.importKbS' })
          } else if (res.message === '导入失败') {
            responseType = 'error'
            responseMsg = this.$t('issue.importKbF', { msg: 'issue.importKbF' })
          }
          this.$notify({
            title: this.$t('issue.importNotify', { msg: 'issue.importNotify' }),
            type: responseType,
            message: responseMsg,
            customClass: 'notify-success',
            offset: 300,
          });

        }).catch(err => {
          this.$message.error(this.$t('issue.error', { msg: 'issue.error' }))
        })
      }).catch(() => {
        this.$message({
          type: 'info',
          message: this.$t('issue.beCancel', { msg: 'issue.beCancel' })
        });
      });
    },
    companyIDchange(row, value) {
      for (let i = 0; i < this.alltype.length; i++) {
        if (this.alltype[i].companyID === row.companyID) {
          row.type = this.alltype[i].value;
          break;
        }
      }
      changeissue(row).then(res => {
        // console.log(res);
      }).catch(err => {
        console.log(err);
      });
    },
    typechange(row, value) { //改变问题类型
      changeissue(row).then(res => {
        // console.log(res);
        this.updatetable();
      }).catch(err => {
        console.log(err);
      });
    },
    urgencychange(label) {
      for (let i = 0; i < this.allurgency.length; i++) {
        if (label === this.allurgency[i].label) {
          this.issue.urgencyID = this.allurgency[i].value;
          this.urgencycolor = this.allurgency[i].color;
          break;
        }
      }
      changeurgency({
        issueid: this.issue.issueid,
        urgencyID: this.issue.urgencyID
      }).then(res => {
        // console.log(res);
      }).catch(err => {
        console.log(err);
      });
      // console.log(this.issue);
    },
    urgencyRadioChange(label) {  //新增问题中优先级按钮的修改
      for (let i = 0; i < this.allurgency.length; i++) {
        if (label === this.allurgency[i].label) {
          this.urgencyradiocolor = this.allurgency[i].color;
          break;
        }
      }
    },
    handleOpen(val) {  //打开抽屉
      this.drawer = true;
      let thisRowData = this;
      thisRowData = val;
      this.issue = thisRowData;
      if (this.creator === this.issue.unReadUser) {
        this.issue.isRead = 1;
        postRequest(baseUrl_New + '/clear/message', this.issue)
          .then(res => {
            this.updatetable();
          })
          .catch(err => {
            console.log(err);
          })

      }
      for (let i = 0; i < this.allurgency.length; i++) {  //渲染优先级按钮组
        if (this.issue.urgencyID === this.allurgency[i].value) {
          this.urgencycolor = this.allurgency[i].color;
          this.issue.urgency = this.allurgency[i].label;
          break;
        }
      }
      this.getFilesList(this.issue.issueid);
      // this.getResList(this.issue.issueid); //不使用了
      this.getCardAllissueId(this.issue.issueid);
      this.getAccountAll(this.issue.issueid);
      this.getLoginUserName();
    },
    handleClose() { //关闭抽屉
      this.drawer = false;
    },
    issueDialogClose() {  //关闭新增对话框
      this.issueDialogVisible = false;
    },
    handleEdit(index, row) { //编辑按钮
      //console.log(index, row);
    },
    handleDelete(index, row) { //删除按钮
      deleteIssue({
        issueid: row.issueid
      }).then(res => {
        // console.log(res);
        this.updatetable();
      }).catch(err => {
        console.log(err);
      });
    },
    tableRowClassName({ row, rowIndex }) {
      if (row.status === 'close') {
        return 'success-row';
      }
      //   if (row.status === 'close') {
      //     return 'success-row';
      //   } else {
      //     return 'warning-row';
      //   }
    },
    companyChange(companyID) {
      this.form.type = '';
      this.form.customerid = '';
      console.log(companyID);
      console.log(this.usercompany);
      let i = 0;
      for (; i < this.usercompany.length; i++) {
        if (this.usercompany[i].companyID === companyID &&
          (this.usercompany[i].roleID === this.allrole.find(item => item.label === '管理员').value ||
            this.usercompany[i].roleID === this.allrole.find(item => item.label === '客服').value)) {
          this.customerVisible = true;
          break;
        }
      }
      if (i === this.usercompany.length)
        this.customerVisible = false;
    },
    getCompanyCache() {
      const username = sessionStorage.getItem('username');
      const data = {
        'username': username,
      }
      getRequest(baseUrl_New + '/companycache', data)
        .then(res => {
          this.form.companyID = res.data.companyIdCache;
          this.companyChange(this.form.companyID);
        }).catch(err => {
          console.log(err);
        });
    },
    getallrole() {  //得到所有角色信息
      getallrole().then(res => {
        this.allrole = res.data;
      }).catch(err => {
        console.log(err);
      })
    },
    //附件
    //上传多余一个文件时
    handleExceed() {
      this.$message.warning(this.$t('issue.fileInfo', { msg: 'issue.fileInfo' }))
    },

    /**  uploadFile(file){
       let formData = new FormData();
       formData.append('file', file.file);
       console.log("formData",formData);
       uploadFile(formData).then(res =>{
         console.log(res,"查看文件返回值");
         this.urlFile=res.data.fileUrl;
       }).catch(err=>{
         
       })
     },*/
    submitUpload() {
      //判断是否有文件再上传
      if (this.fileList.length === 0) {
        return this.$message.warning(this.$t('issue.fileAfterInfo', { msg: 'issue.fileAfterInfo' }))
      }
      let formData = new FormData();
      this.fileList.forEach((file) => {
        formData.append('file', file.raw)
      })
      issueFileAdd(formData).then(res => {
        // console.log(res,"查看文件返回值");
        this.urlFiles = res.data.fileUrls;
        //清空fileList
        this.fileList = [];
        this.$message.success(this.$t('issue.uploadS', { msg: 'issue.uploadS' }))
      }).catch(err => {
        this.$message.warning(this.$t('issue.uploadF', { msg: 'issue.uploadF' }))
      })
    },
    // 文件状态改变时的钩子，添加文件、上传成功和上传失败时都会被调用,function(file, fileList)
    handleChange(file, fileList) {
      this.fileList = fileList
    },
    handleRemove(file, fileList) {
      //console.log(file, fileList);
    },
    handlePreview(file) {
      //console.log(file);
    },
    //上传失败回调
    fileUploadError(error) {
      this.$message.error(this.$t('issue.importF', { msg: 'issue.importF' }))
    },
    //附件下载
    //文件下载
    handleLoad(index, fileUrl) {
      getRequest(baseUrl_New + '/oss/file/downloadFile?fileUrl=' + fileUrl, {
        responseType: 'blob',
        headers: {
          'Content-Type': 'application/octet-stream'
        }
      }).then(response => {
        const url = window.URL.createObjectURL(new Blob([response]));
        const link = document.createElement('a');
        link.href = url;
        const filename = fileUrl.substring(fileUrl.lastIndexOf('/') + 1);
        link.setAttribute('download', filename);
        document.body.appendChild(link);
        link.click();
      }).catch(
        (error) => {
          this.$message.error(this.$t('issue.issueInfoFile', { msg: 'issue.issueInfoFile' }))
        }
      );
    },
    getFilesList(issueId) {
      this.load = true;
      getRequest(baseUrl_New + '/oss/issue/fileList?issueId=' + issueId)
        .then(response => {
          // console.log(response.data);
          let result = response;
          this.filesData = result.list;
          this.load = false;
        })
        .catch(err => {
          ElMessage.error(err)
        })
    },
    handleDelFile(index, id) {
      deleteRequest(baseUrl_New + `/oss/issue/del/${id}`)
        .then(response => {
          if (response.code == 0) {
            ElMessage.success(this.$t('issue.deleteS', { msg: 'issue.deleteS' }));

          } else {
            ElMessage.error(this.$t('issue.deleteF', { msg: 'issue.deleteF' }));
          }
        })
    },
    beforeRemove(file, fileList) {
      return this.$confirm(this.$t('issue.issueInfoFile', { msg: 'issue.issueInfoFile' }));
    },
    submitResUpload() {

      let formData = new FormData();
      this.resFileList.forEach((file) => {
        formData.append('file', file.raw)
      });
      formData.append('issueId', this.issue.issueid)  //追加issueId

      uploadRes(formData).then(res => {
        // 清空resFileList[]
        this.resFileList = [];
        this.$message.success(this.$t('issue.uploadS', { msg: 'issue.uploadS' }));
        this.getResList(this.issue.issueid);
      }).catch(err => {

      })
    },
    handlePreviewRes(file) {
      //console.log(file);
    },
    handleChangeRes(file, resFileList) {
      this.resFileList = resFileList
    },
    handleRemoveRes(file, resFileList) {
      //console.log(file, resFileList);
    },
    getResList(issueId) {
      this.load = true;
      getRequest(baseUrl_New + '/oss/issue/resFileList?issueId=' + issueId)
        .then(response => {
          // console.log(response.data);
          let result = response;
          this.resData = result.list;
          this.load = false;
        })
        .catch(err => {
          ElMessage.error(this.$t('issue.error', { msg: 'issue.error' }));
        })
    },
    handleDelRes(index, id) {
      this.$confirm(this.$t('issue.deleteFileInfo', { msg: 'issue.deleteFileInfo' }), this.$t('issue.tips', { msg: 'issue.tips' }), {
        confirmButtonText: this.$t('issue.table.confirm', { msg: 'issue.table.confirm' }),
        cancelButtonText: this.$t('issue.table.cancel', { msg: 'issue.table.cancel' }),
        cancelButtonClass: 'btn-custom-cancel',
        type: 'warning'
      }).then(() => {
        deleteRequest(baseUrl_New + `/oss/issue/delRes/${id}`)
          .then(response => {
            if (response.code == 0) {
              ElMessage.success(this.$t('issue.deleteS', { msg: 'issue.deleteS' }));
              this.getResList(this.issue.issueid);
            } else {
              ElMessage.error(this.$t('issue.deleteF', { msg: 'issue.deleteF' }));
            }
          })
      })
    },
    handleParse(index, row) {
      this.issue = JSON.parse(JSON.stringify(row));
      this.issueIdTo = this.issue.issueid;
    },
    closeDialog() {
      this.dialogVisible = false;
    },
    //  handleSkip(index, row){ 

    //   this.$router.push({
    //     path:'/issuetrace',
    //     name: 'issuetrace',
    //     params: {
    //       issueId: row.issueid,
    //       title:row.title,

    // 	}
    // });
    //  },
    //问题追踪

    getLoginUserName() {
      this.loginName = sessionStorage.getItem("username");
      this.loginUsername = sessionStorage.getItem('name');
      this.form.engineer = this.loginUsername;
    },

    onSubmitTrace(formName) { // 发送回复
      // 设置 trackLoad 为 true
      this.trackLoad = true;

      // 使用 setTimeout 设置 trackLoad 为 false 并执行 postRequest
      setTimeout(() => {
        this.$refs[formName].validate((valid) => {
          if (valid) {
            var that = this;
            postRequest(baseUrl_New + '/email/record', {
              title: this.issue.title,
              issueId: this.issue.issueid,
              sender: this.loginName,
              // customerId: this.recordForm.customerId,
              issueResponse: this.recordForm.contextResp,
              // isRemind: this.recordForm.isRemind,
              stringUrl: this.recordForm.stringUrl,
            }).then(resp => {
              this.trackLoad = false; // 请求完成后设置 trackLoad 为 false
              if (resp.data.record == 0) {
                this.$message.success(this.$t('issueTrack.emailAccountMsg', { msg: 'issueTrack.emailAccountMsg' }));
                this.resetForm('recordForm');
                this.getCardAllissueId(this.issue.issueid);
                this.$refs.upload.clearFiles();  // 清空图片
                this.recordForm.stringUrl = [];
              } else {
                this.$message.success(this.$t('issueTrack.successMsg', { msg: 'issueTrack.successMsg' }));
                this.resetForm('recordForm');
                this.getCardAllissueId(this.issue.issueid);
                this.$refs.upload.clearFiles();  // 清空图片
                this.recordForm.stringUrl = [];
              }
            }).catch(err => {
              this.trackLoad = false; // 请求失败时也设置 trackLoad 为 false
              this.$message.error(this.$t('issueTrack.errMsg', { msg: 'issueTrack.errMsg' }));
            });
          } else {
            this.trackLoad = false; // 表单验证失败时设置 trackLoad 为 false
            return false;
          }
        });
      }, 2000); // 2秒后执行
    },
    getAccountAll(issueId) {
      getRequest(baseUrl_New + '/email/getEmailAccount/?issueId=' + issueId).then(response => {
        let resultMap = response;
        this.userAccount = resultMap.list;
      })
    },
    //卡片中的问题追踪

    resetForm(form) {  //重置对话栏
      this.$refs[form].resetFields();
      this.recordForm.isRemind = '0';
      this.recordForm.stringUrl = [];
      this.$refs.upload.clearFiles();  //清空图片
    },

    handleRemoveTrace(file, fileList) {
      // console.log(file, fileList);
    },
    handlePreviewTrace(file) {
      // console.log(file);
    },
    handleUploadSuccess(res, file, fileList) { //成功之后把值 传给stringUrl[]
      this.recordForm.stringUrl.push(res.data.fileUrl);

    },
    handleChangeTrace(file, fileList) {
      //  this.recordForm.stringUrl=fileList.response.data;
    },
    //卡片所有回复信息
    getCardAllissueId(issueId) {
      getRequest(baseUrl_New + '/email/getRecordList/?issueId=' + issueId).then(response => {
        // console.log(response);
        this.recordList = response.list;

      })
    },
    copyToClipboard(text) {
      navigator.clipboard.writeText(text).then(() => {
        this.$message.success('邮箱已复制');
      })},
    // 限制图片大小
    handleBeforeUpload(file) {

      const isLt8M = file.size / 1024 / 1024 < 8;

      if (!isLt8M) {
        this.$message.error(this.$t('issueTrack.uploadInfo', { msg: 'issueTrack.uploadInfo' }));
      }
      return isLt8M
    },
    //wangeditor编辑器
    onCreated(editor) {
      this.editor = Object.seal(editor) // 一定要用 Object.seal() ，否则会报错
      i18nChangeLanguage(localStorage.getItem('language')); //编辑框国际化
    },
    onChange(editor) {
      // console.log("onChange", editor.getHtml()); // onChange 时获取编辑器最新内容
    },
    onCreatedDispaly(responseEditor) {
      this.responseEditor = Object.seal(responseEditor)
      i18nChangeLanguage(localStorage.getItem('language'));
    },
    //文件下载
    handleLoadTrace(index, fileUrl) {
      getLoadRequest(baseUrl_New + '/oss/file/downloadFile?fileUrl=' + fileUrl, {
        
        headers: {
          'Content-Type': 'application/octet-stream'
        }
      }).then(response => {
        const url = window.URL.createObjectURL(new Blob([response]));
        const link = document.createElement('a');
        link.href = url;
        const filename = fileUrl.substring(fileUrl.lastIndexOf('/') + 1);
        link.setAttribute('download', filename);
        document.body.appendChild(link);
        link.click();
      }).catch(
        (error) => {
          this.$message.error(this.$t('issue.issueInfoFile', { msg: 'issue.issueInfoFile' }))
        }
      );
    },
    //
    onCreatedContext(contextEditor) {
      this.contextEditor = Object.seal(contextEditor)
      i18nChangeLanguage(localStorage.getItem('language'));
    },
    onCreatedSolution(solutionEditor) {
      this.solutionEditor = Object.seal(solutionEditor)
      i18nChangeLanguage(localStorage.getItem('language'));
    },
    onChangeSolution(solutionEditor) {
      // console.log("onChange", solutionEditor.getHtml()); // onChange 时获取编辑器最新内容
      this.changeissue(this.issue.solution);

    },
    updateChargeTime() {
      changeChargeTime(this.issue).then(res => {
        console.log(res);
        if (res.message === '修改成功') {
          return;
        }
        this.$message.error('error');
      }).catch(err => {
        console.log(err);
      });
    },
    findNewRecord(recordList) {
      if (this.issue.messageQuantity > 0) {
        for (let i = 0; i <= recordList.length - this.issue.messageQuantity; i++) {
          return false;
        }
        for (let i = 0; i <= this.issue.messageQuantity; i++) {
          return true;
        }
      }
      console.log(recordList);
    }
  }
}
</script>
<style src="@wangeditor/editor/dist/css/style.css"></style>

<style>
/*修复问题标题输入框长度限制与输入字符重叠*/
.el-input__inner,
[maxlength] {
  padding-right: 60px;
}

.el-table .success-row {
  /* background-color: #f0f9eb; */
  height: 10px;
}

.el-table .warning-row {
  /* background-color: oldlace; */
  height: 10px;
}

/* .warning-row:hover > td{
  background-color: #FDE9C3 !important;
}

.success-row:hover > td{
  background-color: #D9F9C8 !important;
} */

.el-drawer__body {
  overflow-y: scroll;
}

.el-select {
  width: 300px
}

/*修改滚动条样式*/
div ::-webkit-scrollbar {
  width: 10px;
  height: 10px;
  /**/
}

div ::-webkit-scrollbar-track {
  background: rgb(239, 239, 239);
  border-radius: 2px;
}

div ::-webkit-scrollbar-thumb {
  background: #bfbfbf;
  border-radius: 10px;
}

div ::-webkit-scrollbar-thumb:hover {
  background: #333;
}

div ::-webkit-scrollbar-corner {
  background: #179a16;
}

.btn-custom-cancel {
  float: right;
  margin-left: 10px;
}

.notify-success {
  position: fixed;
  /* 使用固定定位 */
  top: 50%;
  /* 将顶部设置为50%，使其垂直居中 */
  left: 50%;
  /* 将左侧设置为50%，使其水平居中 */
  transform: translate(-50%, -50%);

}
.demo-table-expand {
    font-size: 0;
  }
  .demo-table-expand label {
    width: 90px;
    color: #99a9bf;
  }
  .demo-table-expand .el-form-item {
    margin-right: 0;
    margin-bottom: 0;
    width: 50%;
  }
  .el-dialog__body {
  overflow: hidden;
}

.tag-margin {
  margin-right: 5px;
  margin-bottom: 5px;

}


.biography {
  display: -webkit-box;
  -webkit-line-clamp: 2;
  -webkit-box-orient: vertical;
  overflow: hidden;
  text-overflow: ellipsis;
  word-wrap: break-word;
}
.demo-table-expand {
  text-align: left;
}
</style>
